/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  0.25: '0.0625rem',
  0.5: '0.125rem',
  0.65: '0.1625rem',
  0.75: '0.1875rem',
  1: '0.25rem',
  1.25: '0.3125rem',
  1.375: '0.34375rem',
  1.5: '0.375rem',
  1.75: '0.4375rem',
  2: '0.5rem',
  2.25: '0.5625rem',
  2.375: '0.59375rem',
  2.5: '0.625rem',
  2.75: '0.6875rem',
  3: '0.75rem',
  3.25: '0.8125rem',
  3.5: '0.875rem',
  3.75: '0.9375rem',
  4: '1rem',
  4.25: '1.0625rem',
  4.5: '1.125rem',
  4.7: '1.175rem',
  4.75: '1.1875rem',
  5: '1.25rem',
  5.25: '1.3125rem',
  5.5: '1.375rem',
  5.75: '1.4375rem',
  6: '1.5rem',
  6.25: '1.5625rem',
  6.5: '1.625rem',
  6.75: '1.6875rem',
  6.875: '1.71875rem',
  7: '1.75rem',
  7.25: '1.8125rem',
  7.5: '1.875rem',
  8: '2rem',
  8.5: '2.125rem',
  8.75: '2.1875rem',
  9: '2.25rem',
  9.5: '2.375rem',
  10: '2.5rem',
  10.25: '2.5625rem',
  10.5: '2.625rem',
  11: '2.75rem',
  11.25: '2.8125rem',
  11.75: '2.9375rem',
  12: '3rem',
  12.5: '3.125rem',
  12.75: '3.1875rem',
  13: '3.25rem',
  13.25: '3.3125rem',
  13.5: '3.375rem',
  13.75: '3.4375rem',
  14: '3.5rem',
  15: '3.75rem',
  15.25: '3.8125rem',
  15.5: '3.875rem',
  16: '4rem',
  17: '4.25rem',
  17.5: '4.375rem',
  18: '4.5rem',
  18.25: '4.5625rem',
  18.5: '4.625rem',
  19: '4.75rem',
  19.5: '4.875rem',
  20: '5rem',
  21: '5.25rem',
  22.5: '5.625rem',
  24: '6rem',
  25: '6.25rem',
  26.75: '6.6875rem',
  27.5: '6.875rem',
  27.75: '6.9375rem',
  28: '7rem',
  29.25: '7.3125rem',
  30: '7.5rem',
  31.25: '7.8125rem',
  32: '8rem',
  35: '8.75rem',
  37: '9.25rem',
  37.5: '9.375rem',
  39.5: '9.875rem',
  21.25: '5.3125rem',
  32.5: '8.125rem',
  42: '10.5rem',
  50: '12.5rem',
  55: '13.75rem',
  63.875: '15.96875rem',
  66.5: '16.625rem',
  72.5: '18.125rem',
  75: '18.75rem',
  76.5: '19.125rem',
  77.5: '19.375rem',
};
